/** Exact-instance ownership of dispatch visuals, events and hover animation. */
export function createDispatchMarker({ map, position, icon, zIndex, title, onClick, onContextMenu }) {
  const element = new window.google.maps.marker.AdvancedMarkerElement({
    position, zIndex, title, gmpClickable: true,
    anchorLeft: '-50%', anchorTop: '-50%',
    collisionBehavior: window.google.maps.CollisionBehavior.REQUIRED,
  });
  const image = document.createElement('img');
  image.alt = '';
  image.draggable = false;
  image.style.display = 'block';
  image.style.maxWidth = 'none';
  let active = true;
  let animation;
  const setVisual = visual => {
    if (!active) return;
    image.src = visual.url;
    image.width = visual.width;
    image.height = visual.height;
  };
  const click = event => { if (active) onClick(event); };
  const contextMenu = event => {
    event.preventDefault();
    event.stopPropagation();
    if (active) onContextMenu(event);
  };
  const dispose = () => {
    if (!active) return;
    active = false;
    animation?.cancel();
    element.removeEventListener('gmp-click', click);
    image.removeEventListener('contextmenu', contextMenu);
    element.map = null;
    image.remove();
  };
  try {
    setVisual(icon);
    element.appendChild(image);
    element.addEventListener('gmp-click', click);
    image.addEventListener('contextmenu', contextMenu);
    element.map = map;
  } catch (error) {
    dispose();
    throw error;
  }
  return {
    element,
    setVisual,
    bounce() {
      if (!active) return;
      animation?.cancel();
      // Animate the owned child, not Google's positioning/anchor transform.
      animation = image.animate?.([
        { transform: 'translateY(0)', easing: 'ease-out' },
        { transform: 'translateY(-14px)', offset: 0.5, easing: 'ease-in' },
        { transform: 'translateY(0)' },
      ], { duration: 350, iterations: 2 });
    },
    dispose,
  };
}
